import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { fetchToken, fetchSelfUserInfo } from '../components/Auth';

import axios from 'axios';
// import { useForm } from 'react-hook-form';
// import { DataGrid } from '@mui/x-data-grid';

import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Nav from 'react-bootstrap/Nav';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import BSTooltip from 'react-bootstrap/Tooltip';
import Pagination from 'react-bootstrap/Pagination';
// import Navbar from 'react-bootstrap/Navbar';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

import { DatatableWrapper, Filter, TableBody, TableHeader } from 'react-bs-datatable';
import { Collapse, Table } from 'react-bootstrap';

import Header from '../components/Header';
import Footer from '../components/Footer';

import { getUnits } from '../components/ApiAccess';
import { useGetApi } from '../components/ApiAccess';
import { getSelfClient } from '../components/ApiAccess';
import { ClientName } from '../components/ApiAccess';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const dateFormatter = (date) => {
  if (!date) {
    date = new Date();
  }
  const y = date.getFullYear();
  const m = ('00' + (date.getMonth() + 1)).slice(-2);
  const d = ('00' + date.getDate()).slice(-2);
  return y + '-' + m + '-' + d;
};

const getAfterNDays = (date, n) => {
  date = new Date(date);
  date.setDate(date.getDate() + n);
  return dateFormatter(date);
};

const CurrentUnitName = ({ unitId, setInputDate }) => {
  const [unitName, setUnitName] = useState();
  const getCurrentUnit = useGetApi('/api/v1/units/' + unitId + '/');

  useEffect(() => {
    getCurrentUnit().then((response) => {
      setUnitName(response.data.name);

      let today = dateFormatter();
      let initDate = { start: today, end: today };

      if (response.data.scope_end) {
        //終了日が存在する場合
        initDate.start = response.data.scope_start;
        initDate.end = response.data.scope_end;
      } else if (response.data.scope_start > today) {
        //終了日が存在せず、今日＜開始日の場合
        initDate.start = dateFormatter();
        initDate.end = getAfterNDays(initDate.start, 6);
      } else if (response.data.scope_start === today) {
        //終了日が存在せず、今日＝開始日の場合
        initDate.end = dateFormatter();
        initDate.start = getAfterNDays(initDate.end, -6);
      } else if (response.data.scope_start < today) {
        //終了日が存在せず、開始日＜今日の場合
        initDate.start = response.data.scope_start;
        initDate.end = dateFormatter();
      }
      setInputDate(initDate);
    });
  }, []);

  return <>{unitName}</>;
};

// ------------------------------------------施策一覧---------------------------------------
const UnitsListNav = ({ clientId, mode }) => {
  const [unitList, setUnitList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageTotal, setPageTotal] = useState(0);
  const [isReadAll, setIsReadAll] = useState(false);

  useEffect(() => {
    const limit = 100;
    const skip = limit * (currentPage - 1);
    getUnits(clientId, skip, limit).then((response) => {
      if (response.status === 200) {
        const data = response.data;
        setUnitList((prev) => [...prev, ...data]);

        const newPageTotal = Math.ceil(response.count / limit);
        setPageTotal(newPageTotal);
        currentPage === newPageTotal && setIsReadAll(true);
      }
    });
  }, [currentPage]);

  return (
    <div className='units-list-nav'>
      <ul className="nav flex-column m-0 py-3 ps-4 flex-nowrap">
        {unitList.map((unit, index) => (
          <OverlayTrigger
            key={index}
            placement="top"
            trigger={['hover', 'focus']}
            overlay={<BSTooltip id="info-tooltip-unit">{unit.name}</BSTooltip>}
          >
            <li className="nav-item unit-list-nav-item">
              {mode ? (
                <>
                  <Nav.Link
                    href={'../self/' + unit.id}
                    className="text-black fw-bold ps-0 unit-list-nav-link"
                  >
                    {/* <img src="/manager/envelope-fill.svg" width="20px" /> */}
                    {unit.name}
                  </Nav.Link>
                </>
              ) : (
                <>
                  <Nav.Link
                    href={'../units/' + unit.id}
                    className="text-black fw-bold ps-0 unit-list-nav-link"
                  >
                    {/* <img src="/manager/envelope-fill.svg" width="20px" className="me-1 pb-1" /> */}
                    {unit.name}
                  </Nav.Link>
                </>
              )}
            </li>
          </OverlayTrigger>
        ))}
      </ul>{' '}
      {!isReadAll && (
        <div className="text-center pb-3">
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => setCurrentPage((prev) => prev + 1)}
          >
            more
          </Button>
        </div>
      )}
    </div>
  );
};

const gridDateTimeFormatter = (value) => {
  const d = new Date(value);
  return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
};

// ------------------------------------------アクセスログ---------------------------------------
const CustomerSummaryTbl = ({ unitId, inputDate }) => {
  const [summaryData, setSummaryData] = useState([]);

  useEffect(() => {
    if (inputDate.start) {
      getCustomerSummary(unitId, inputDate).then((response) => {
        const customerSummary = response.data.map((r) => {
          r.id = r.customer;
          return r;
        });
        setSummaryData(customerSummary);
      });
    }
  }, [inputDate]);

  const header = [
    // { title: 'client_code', prop: 'client' },
    // { title: 'unit_code', prop: 'unit' },
    { title: 'customer_code', prop: 'customer' },
    {
      title: 'first_visit',
      prop: 'first',
      cell: (row) => (
        <>
          <span>{gridDateTimeFormatter(row.first)}</span>
        </>
      ),
    },
    {
      title: 'last_visit',
      prop: 'last',
      cell: (row) => (
        <>
          <span>{gridDateTimeFormatter(row.last)}</span>
        </>
      ),
    },
    { title: 'access_count', prop: 'count' },
    {
      title: 'free_text',
      prop: 'free_text',
      cell: (row) => (
        <>
          <OverlayTrigger
            placement="top"
            overlay={<BSTooltip id="free-text-tooltip">{row.free_text}</BSTooltip>}
          >
            <span>{row.free_text}</span>
          </OverlayTrigger>
        </>
      ),
    },
  ];

  const getCustomerSummary = (unitId, inputDate) => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };

    return axios
      .get(
        '/api/v1/units/' +
          unitId +
          '/summary/?start=' +
          inputDate.start +
          '&end=' +
          inputDate.end +
          '&limit=100',
        { headers: headers },
      )
      .then((response) => {
        return response;
      });
  };

  return (
    <>
      <DatatableWrapper headers={header} body={summaryData}>
        <Row>
          <Col></Col>
          <Col></Col>
          <Col></Col>
          <Col></Col>
          <Col className="free-text"></Col>
        </Row>
        <Table>
          <TableHeader />
          <TableBody />
        </Table>
      </DatatableWrapper>{' '}
    </>
  );
};

// ------------------------------------------集計データダウンロード---------------------------------------
const CsvDownloadBtn = ({ unitId, inputDate }) => {
  const downloadBtnHandler = (unitId, inputDate) => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };

    let filename;

    axios
      .get(
        '/api/v1/units/' +
          unitId +
          '/summary/?csv=true&start=' +
          inputDate.start +
          '&end=' +
          inputDate.end,
        {
          headers: headers,
          responseType: 'blob',
        },
      )
      .then((response) => {
        const disposition = response.headers['content-disposition'];
        filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];
        if (filename.toLowerCase().startsWith("utf-8''"))
          filename = decodeURIComponent(filename.replace("utf-8''", ''));
        else filename = filename.replace(/['"]/g, '');
        return response.data;
      })
      .then((blob) => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a); // append the element to the dom
        a.click();
        a.remove(); // afterwards, remove the element
      })
      .catch((error) => {});
  };

  return (
    <>
      <Button
        variant="outline-dark"
        onClick={(event) => downloadBtnHandler(unitId, inputDate)}
        className="csv-dl-button"
      >
        集計データダウンロード
        <img src="/manager/csv-dl.svg" width="8px" className="ms-3 pb-1" />
      </Button>
    </>
  );
};

// ------------------------------------------チャート---------------------------------------
const DailySummaryChart = ({ unitId, inputDate, setInputDate }) => {
  const [datasets, setDatasets] = useState({ datasets: [{ data: [] }], labels: [] });
  // const [dailySummaryLimit, setDailySummaryLimit] = useState(7);

  const getBeforeNDays = (n) => {
    const date = new Date();
    date.setDate(date.getDate() - n);
    return dateFormatter(date);
  };

  // const [inputDate, setInputDate] = useState({ start: getBeforeNDays(6), end: getBeforeNDays(0) });
  // const [inputDate, setInputDate] = useState({start: dateFormatter(), end: dateFormatter()});

  const options = {
    responsive: true,
    scales: {
      x: {
        reverse: true,
      },
      y: {
        ticks: {
          callback: function (value, index, ticks) {
            if (Math.floor(value) === value) {
              return value;
            }
          },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        position: 'top',
      },
      title: {
        display: false,
        text: 'Chart.js Bar Chart',
      },
    },
  };

  useEffect(() => {
    if (inputDate.start) {
      getDailySummary(unitId, inputDate).then((response) => {
        const data = response.data
          .map((d) => ({ [new Date(d.access_date).toLocaleDateString()]: d.count }))
          .reduce((l, r) => Object.assign(l, r), {});

        const dailySummaryData = {
          datasets: [{ data: [], backgroundColor: 'rgba(53, 162, 235, 0.5)', label: 'アクセス数' }],
          labels: [],
        };

        const start = new Date(inputDate.start);
        const now = new Date(inputDate.end);
        // start.setDate(now.getDate() - dailySummaryLimit);
        for (let d = now; d >= start; d.setDate(d.getDate() - 1)) {
          let count = data[d.toLocaleDateString()] || 0;
          dailySummaryData.datasets[0].data.push(count);
          dailySummaryData.labels.push(d.toLocaleDateString());
        }

        setDatasets(dailySummaryData);
      });
    }
  }, [inputDate]);

  const getDailySummary = (unitId, inputDate) => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };
    return axios
      .get(
        '/api/v1/units/' +
          unitId +
          '/summary/daily?start=' +
          inputDate.start +
          '&end=' +
          inputDate.end,
        { headers: headers },
      )
      .then((response) => {
        return response;
      });
  };

  const selectChangeHandler = (event) => {
    // setDailySummaryLimit(event.target.value);
    const diff = event.target.value - 1;
    setInputDate({ start: getBeforeNDays(diff), end: getBeforeNDays(0) });
  };

  return (
    <>
      <div className='daily-summary-chart'>
        <Form.Group as={Container} className="" controlId="interval">
          <Row>
            <Col>
              <p>期間設定</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Label>開始</Form.Label>
              <Form.Control
                type="date"
                value={inputDate.start}
                onChange={(event) => setInputDate({ ...inputDate, start: event.target.value })}
              />
            </Col>
            <Col>
              <Form.Label>終了</Form.Label>
              <Form.Control
                type="date"
                value={inputDate.end}
                onChange={(event) => setInputDate({ ...inputDate, end: event.target.value })}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <p className='chart-shortcut-label'>
                期間設定ショートカット:
                <Button
                  variant="link"
                  onClick={(event) => selectChangeHandler(event)}
                  value="1"
                  className="chart-shortcut"
                >
                  今日
                </Button>
                <Button
                  variant="link"
                  onClick={(event) => selectChangeHandler(event)}
                  value="7"
                  className="chart-shortcut"
                >
                  1週間
                </Button>
                <Button
                  variant="link"
                  onClick={(event) => selectChangeHandler(event)}
                  value="30"
                  className="chart-shortcut"
                >
                  1ヶ月
                </Button>
              </p>
            </Col>
          </Row>
        </Form.Group>
      </div>

      <div>
        <div className="chart-wrapper chart-body">
          <Bar data={datasets} options={options} />
        </div>
      </div>
    </>
  );
};

export default function AccessLog({ mode }) {
  const navigate = useNavigate();
  const params = useParams();

  const [clientId, setClientId] = useState();
  const [unitId, setUnitId] = useState();

  const [inputDate, setInputDate] = useState({ start: '', end: '' });

  useEffect(() => {
    if (!clientId) {
      if (params.clientId) {
        setClientId(params.clientId);
      } else {
        getSelfClient().then((response) => {
          setClientId(response.data.id);
        });
      }

      setUnitId(params.unitId);
    }
  }, []);

  const handleEditUnit = (event) => {
    navigate('./edit');
  };

  return (
    <div className='access-log'>
      <Header></Header>
      <main>
        {clientId ? (
          <>
            <div className="d-flex flex-row w-100 accessLog-container">
              <div className="accessLog-container-left">
                {/* サイド施策一覧 */}
                <UnitsListNav clientId={clientId} mode={mode} />
              </div>
              <div className="accessLog-container-left-spacer"></div>

              <div className="accessLog-container-center">
                <Container>
                  <Row>
                    <Col className="text-end">
                      <Button variant="none" onClick={() => navigate(-1)}>
                        <img src="/manager/back.svg" width="15px" />
                      </Button>
                    </Col>
                    <Col xs={8}>
                      <h2>
                        {/* 会社名 */}
                        <ClientName clientId={clientId} />
                      </h2>
                    </Col>
                    <Col></Col>
                  </Row>

                  {unitId ? (
                    <>
                      {/* グラフ */}
                      <div className={'accessLog-wrapper'}>
                        <div
                          className="text-end mb-3 unit-edit-button">
                          <Button
                            variant="dark"
                            size="sm"
                            onClick={(event) => {
                              handleEditUnit(event);
                            }}
                          >
                            施策編集
                          </Button>
                        </div>
                        <h3>
                          <CurrentUnitName unitId={unitId} setInputDate={setInputDate} />
                        </h3>
                        <DailySummaryChart
                          unitId={unitId}
                          inputDate={inputDate}
                          setInputDate={setInputDate}
                        />
                      </div>

                      {/* ランキング */}
                      <div className={'accessLog-wrapper'}>
                        <h3>アクセスログ</h3>

                        <div className="accessLogs-table">
                          <CustomerSummaryTbl unitId={unitId} inputDate={inputDate} />
                        </div>
                        <p className="text-center">
                          最終アクセス日時の降順で最大100件まで表示しています。
                          <br />
                          以下のボタンから選択期間中の全QRアクセス集計データを
                          <br />
                          CSV形式でダウンロードいただけます。
                        </p>
                        <div className="text-center">
                          <CsvDownloadBtn unitId={unitId} inputDate={inputDate} />
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </Container>
              </div>

              <div className="accessLog-container-right"></div>
            </div>
          </>
        ) : (
          <></>
        )}
      </main>
      <Footer />
    </div>
  );
}
